import { useEffect, useState } from "react";
import "./Timer.css";

const Timer = ({ endDate, onTimerEnd }) => {
    const [timeLeft, setTimeLeft] = useState("");
    const [isCritical, setIsCritical] = useState(false);

    useEffect(() => {
        if (!endDate) {
            setTimeLeft("-- -- -- --");
            return;
        }

        const interval = setInterval(() => {
            const now = new Date();
            const distance = new Date(endDate) - now;

            if (isNaN(distance)) {
                setTimeLeft("-- -- -- --");
                clearInterval(interval);
                return;
            }

            if (distance <= 0) {
                setTimeLeft("00J 00H 00M 00S");
                clearInterval(interval);
                if (onTimerEnd) onTimerEnd();
            } else {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((distance / (1000 * 60)) % 60);
                const seconds = Math.floor((distance / 1000) % 60);

                // Dernières 5 minutes = mode critique
                setIsCritical(distance < 1000 * 60 * 5);

                setTimeLeft(
                    `${days.toString().padStart(2, "0")}J ` +
                    `${hours.toString().padStart(2, "0")}H ` +
                    `${minutes.toString().padStart(2, "0")}M ` +
                    `${seconds.toString().padStart(2, "0")}S`
                );
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [endDate, onTimerEnd]);

    return (
        <div className="timer-wrapper">
            <div className={`timer-led ${isCritical ? "critical" : ""}`}>
                {timeLeft}
            </div>
            <div className="timer-label">
                AVANT LE ROYAL RUMBLE
            </div>
        </div>
    );
};

export default Timer;